import {
  AnalyticsEventBuilder,
  AnalyticsEvent,
  AnalyticsEventAction,
} from "./../AnalyticsEventBuilder";
import { Game } from "../../../models/Game";
import { WebVitals } from '../../../models/WebVitals';

export class GeneralAnalyticsAi {
  promoBox(categories: string): AnalyticsEvent {
    const event = this.newEventBuilder();
    event.setName("promobox");
    event.setEventAction(AnalyticsEventAction.IMPRESSION);
    event.setNonInteraction(true);
    event.setCustom("promoboxImpression", `${categories}`.toLowerCase());
    event.setCustom("theatreModeOn", false);
    return event.build();
  }

  promoBoxSlot(
    game: Game,
    promoBoxSlotTitle: string,
    index: number
  ): AnalyticsEvent {
    const event = this.newEventBuilder();
    event.setName("promoboxSlot");
    event.setEventAction(AnalyticsEventAction.CLICK);
    event.setNonInteraction(false);
    event.setGame(game);
    event.setCustom(
      "promoboxSlotClick",
      `${promoBoxSlotTitle} | ${game.slug} | ${index}`.toLowerCase()
    );
    event.setCustom("theatreModeOn", false);
    return event.build();
  }

  topNavClick(category: string, index: number): AnalyticsEvent {
    const event = this.newEventBuilder();
    event.setName("topnavSlot");
    event.setEventAction(AnalyticsEventAction.CLICK);
    event.setNonInteraction(false);
    event.setCustom("topnavClick", `${category}|${index}`);
    event.setCustom("theatreModeOn", false);
    return event.build();
  }

  displayAd(refresh: boolean): AnalyticsEvent {
    const event = this.newEventBuilder();
    event.setName("displayAd");
    event.setEventAction(AnalyticsEventAction.IMPRESSION);
    event.setNonInteraction(true);
    return event.build();
  }

  searchBoxStart(): AnalyticsEvent {
    const event = this.newEventBuilder();
    event.setName("SearchBox");
    event.setEventAction(AnalyticsEventAction.START);
    event.setNonInteraction(false);
    return event.build();
  }

  searchBoxQuery(searchText: string): AnalyticsEvent {
    const event = this.newEventBuilder();
    event.setName("SearchBox");
    event.setEventAction(AnalyticsEventAction.QUERY);
    event.setNonInteraction(false);
    event.setCustom("searchQuery", searchText);
    return event.build();
  }

  searchBoxSelect(searchText: string, game: Game): AnalyticsEvent {
    const event = this.newEventBuilder();
    event.setName("SearchBox");
    event.setEventAction(AnalyticsEventAction.CLICK);
    event.setNonInteraction(false);
    if (game) {
      event.setGame(game);
    }
    event.setCustom("searchQuery", searchText);
    return event.build();
  }

  yellowBanner(id: string, isTheaterMode: boolean): AnalyticsEvent {
    const event = this.newEventBuilder();
    event.setName("yellowBanner");
    event.setEventAction(AnalyticsEventAction.CLICK);
    event.setNonInteraction(false);
    event.setCustom("linkIdClick", `${id}`);
    event.setCustom("theatreModeOn", isTheaterMode);
    return event.build();
  }

  webVitals(metrics: WebVitals): AnalyticsEvent {
    const event = this.newEventBuilder();

    event.setName('WebVitals');
    event.setNonInteraction(true);
    Object.keys(metrics).forEach(key => {
        event.setCustom(key, metrics[key]);
    });

    return event.build();
}

  private newEventBuilder(): AnalyticsEventBuilder {
    return new AnalyticsEventBuilder().baseEvent();
  }
}
